module.exports = __webpack_public_path__ + "static/media/SmartPay.5db26dbd.png";